<template>
    <div class="mb-box" ref="mbBox">
        <div class="mb-box__item mb-box__item--game">
            <div class="mb-box__icon mb-box__info" @click.prevent.stop="toggleModalInfo">
                <IconInfoActive v-if="isInfoHover"></IconInfoActive>
                <IconInfo v-else></IconInfo>
            </div>

            <figure class="mb-box__img" :style="{ 'border-color': color }" @click.prevent.stop="showGameIframe">
                <Image :image="item.image" :width="440" :height="248"></Image>
            </figure>

            <h2 class="mb-box__title" @click.prevent.stop="showGameIframe">{{ item.title }}</h2>

            <transition name="fade" appear>
                <ModalDetails
                    v-if="isModalInfo"
                    @toggleModalInfo="toggleModalInfo"
                    :image="item.image"
                    :title="item.title"
                    :lead="item.lead"
                    :color="color"
                ></ModalDetails>
            </transition>

            <transition name="fade" appear>
                <ModalIframe
                    v-if="isModalGame"
                    :url="`${item.url}&showclose=1&showdownload=1&v=2`"
                ></ModalIframe>
            </transition>      

        <ModalTimeLimit 
            v-if="isModalTimeLimit && activeSubProfile && activeSubProfile._id" 
            :isTimeIsUp="isTimeIsUp"
            :isOutOfHours="isOutOfHours"
            :isTimeIsUpRemind="isTimeIsUpRemind"
            :activeSubProfile="activeSubProfile"
            @closeModalHandle="closeModalHandle"
            @stopRecordTime="stopRecordTime">
        </ModalTimeLimit>
        </div>
    </div>
</template>

<script>
import Image from "../elements/Image.vue";
import IconInfo from "../elements/icons/IconInfo.vue";
import IconInfoActive from "../elements/icons/IconInfoActive.vue";
import ModalDetails from "../modals/ModalDetails.vue";
import ModalIframe from "../modals/ModalIframe.vue";
import ModalTimeLimit from "../modals/ModalTimeLimit.vue";
import { recordTime } from '../../mixins/recordTime';
import { registerVisit } from '../../mixins/registerVisit';
import { checkIsOutOfHours } from '../../mixins/checkIsOutOfHours';
import globalDataLayer from '../../mixins/globalDataLayer';

export default {
    name: "MbBoxGame",
    props: {
        item: {
            type: Object
        },
        activeGameId: {
            type: String
        }
    },    
    mixins: [recordTime, registerVisit, globalDataLayer, checkIsOutOfHours],
    data() {
        return {
            isModalInfo: false,
            isModalGame: false,
            isInfoHover: false,
            recordTimeIntervalId: null,
            checkHoursIntervalId: null,
            isModalTimeLimit: false
        };
    },
    components: {
        Image,
        IconInfo,
        IconInfoActive,
        ModalDetails,
        ModalIframe,
        ModalTimeLimit
    },
    watch: {
        isModalTimeLimit(value) {
            if(value) {
                this.$store.dispatch("changeModalBackdrop", true);
                this.$store.dispatch("changeModalTimeLimitState", true);
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
                this.$store.dispatch("changeModalTimeLimitState", false);
            }
        },
        activeSubProfile(value) {
            if(this.isModalGame) {
                if(value && value._id && value.game_restriction !==0 && this.categoryId) {
                    if(this.isTimeIsUp || (value.remaining_time === 0 && !value.play_from)) {
                        if(!this.value.play_from && !this.value.play_to) {
                            this.isModalTimeLimit = true;  
                            clearInterval(this.recordTimeIntervalId);
                            clearInterval(this.checkHoursIntervalId);
                            this.recordTimeIntervalId = null;
                            this.checkHoursIntervalId = null;    
                        }
                    } else if(this.isOutOfHours) {
                        this.isModalTimeLimit = true;  
                        clearInterval(this.recordTimeIntervalId);
                        clearInterval(this.checkHoursIntervalId);
                        this.recordTimeIntervalId = null;
                        this.checkHoursIntervalId = null; 
                    } else {
                        checkIsOutOfHours();
                        this.recordTimeIntervalId = recordTime(this.categoryId);
                        this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                    }

                    setTimeout(() => {
                        registerVisit(this.item._id, this.activeSubProfile._id)
                    }, 15000);  
                } else {
                    if(this.recordTimeIntervalId) {
                        clearInterval(this.recordTimeIntervalId);
                        this.recordTimeIntervalId = null;
                    }
                    if(this.checkHoursIntervalId) {
                        clearInterval(this.checkHoursIntervalId)
                        this.checkHoursIntervalId = null;  
                    }                
                }
            }
        },
        isTimeIsUp(value) {
            if(this.isModalGame && this.activeSubProfile && this.activeSubProfile._id) {
                if(value && !this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null; 

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null; 
                } else {
                    this.recordTimeIntervalId = recordTime(this.categoryId);
                }
            }
        },
        isTimeIsUpRemind(value) {
            if(this.activeSubProfile && this.activeSubProfile._id && this.isModalGame) {
                if(value && !this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  
                }
            }
        },         
        isOutOfHours(value) {
            if(this.isModalGame && this.activeSubProfile && this.activeSubProfile._id) {
                if(value) {
                    this.isModalTimeLimit = true;  

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null; 

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null; 
                } else {
                    this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                    this.recordTimeIntervalId = recordTime(this.categoryId);
                }
            }
        }                  
    },
    computed: {
        color() {
            let color = this.$store.getters.getCategoryColor;

            if(color) {
                return color;
            } else if (this.item.breadcrumbs && this.item.breadcrumbs[0] && this.item.breadcrumbs[0].color) {
                return this.item.breadcrumbs[0].color;
            }

            return null;
        },        
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        categoryId() {
            if(this.item && this.item.breadcrumbs && this.item.breadcrumbs[0] && this.item.breadcrumbs[0]._id) {
                return this.item.breadcrumbs[0]._id;
            }
            return null;
        },
        isTimeIsUp() {
            return this.$store.getters.isTimeIsUp;
        },
        isTimeIsUpRemind() {
            return this.$store.getters.isTimeIsUpRemind;
        },
        isOutOfHours() {
            return this.$store.getters.isOutOfHours;
        }
    },    
    methods: {
        showGameIframe() {
            if(this.isTimeIsUp || (this.activeSubProfile && this.activeSubProfile.remaining_time === 0 && !this.activeSubProfile.play_from)) {
                if(!this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  
                    clearInterval(this.recordTimeIntervalId);
                    clearInterval(this.checkHoursIntervalId);
                    this.recordTimeIntervalId = null;
                    this.checkHoursIntervalId = null;    
                } else if(this.isOutOfHours) {
                    this.isModalTimeLimit = true;  
                    clearInterval(this.recordTimeIntervalId);
                    clearInterval(this.checkHoursIntervalId);
                    this.recordTimeIntervalId = null;
                    this.checkHoursIntervalId = null; 
                }
            } else if(this.isOutOfHours) {
                this.isModalTimeLimit = true;  
                clearInterval(this.recordTimeIntervalId);
                clearInterval(this.checkHoursIntervalId);
                this.recordTimeIntervalId = null;
                this.checkHoursIntervalId = null; 
            } else {
                this.isModalGame = !this.isModalGame;

                if(this.isModalGame) {
                    if(this.categoryId && this.activeSubProfile) {
                        this.recordTimeIntervalId = recordTime(this.categoryId);
                        this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                        setTimeout(() => {
                            registerVisit(this.item._id, this.activeSubProfile._id)
                        }, 15000);                    
                    }                
                } else {
                    clearInterval(this.intervalId);
                    this.intervalId = null;                
                }
            }
        }, 
        toggleModalInfo() { 
            this.isModalInfo = !this.isModalInfo;
        },
        receiveMessage(e) {
            if(e.origin === 'http://s.v3.tvp.pl' || e.origin === 'https://s.v3.tvp.pl' || e.origin === 'http://s.tvp.pl' || e.origin === 'https://s.tvp.pl') {
                if(e.data && e.data.close) {
                    this.isModalGame = false;
                }
            }
        },
        closeModalHandle() {
            this.isModalTimeLimit = false;
        },
        stopRecordTime() {
            clearInterval(this.recordTimeIntervalId);
            this.recordTimeIntervalId = null; 
        }        
    },
    mounted() {
        window.addEventListener('message', this.receiveMessage);

        if(this.activeGameId && this.activeGameId == this.item._id) {
            this.showGameIframe();
        }

        if(this.activeSubProfile && this.activeSubProfile._id) {
            checkIsOutOfHours();
        }

        if(this.activeSubProfile && this.activeSubProfile.remaining_time === 0 && !this.activeSubProfile.play_from) {
            this.$store.dispatch("setIsTimeIsUp", true);
        }         
    },
    unmounted() {
        this.$store.dispatch("setIsOutOfHours", false);  
        this.$store.dispatch("setIsTimeIsUp", false);
        this.$store.dispatch("changeModalBackdrop", false);
        this.$store.dispatch("changeModalTimeLimitState", false);
        clearInterval(this.recordTimeIntervalId);
        clearInterval(this.checkHoursIntervalId);
        this.recordTimeIntervalId = null;
        this.checkHoursIntervalId = null;          
    }
};
</script>